import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';

import { DataService } from '../services/data.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(private dataService: DataService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      return next.handle(request).do((event: HttpEvent<any>) => {

        if (event instanceof HttpResponse) {
          
          // for testing
          if (event.ok === true && event.status === 204) {
            return event;
          }
          // for testing

          if (event.body.status_code === 401) {
            this.dataService.clearUserData();
          }
        }
      }, (err: any) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status === 401) {
              this.dataService.clearUserData();
          }
          if (err.status === 404) {
          //  this.dataService.redirectToDashboard('Page not found');
          }
          if (err.status === 403) {
             this.dataService.redirectToDashboard('You do not have access to this page');
          }
        }
      });
    }
  }



// WEBPACK FOOTER //
// ./src/app/interceptors/auth.interceptor.ts